/**
 * 商品
 */

import { HTTP_ALB } from '../axios'

//  商品列表
export const getshoplist = params => {
  return HTTP_ALB.get('/foundation/shop/list', params)
}

// 添加商品
export const addshop = params => {
  return HTTP_ALB.post('/foundation/shop/add', params)
}
// 编辑商品
export const editshop = params => {
  return HTTP_ALB.post('/foundation/shop/edit', params)
}

// 删除商品
export const deleteshop = params => {
  return HTTP_ALB.get('/foundation/shop/del', params)
}
